(function () {
  'use strict';

  var LOGO_PREFIX = 'Lisää ennalta toimitetut logot työvaatteisiin\n';
  var MAX_NOTE = 250;

  var state = {
    logo: null,
    note: ''
  };

  var debounceTimer = null;
  var drawerObserverInstalled = false;

  // ── Cart note sync ────────────────────────────────────────────

  function buildFullNote() {
    var n = state.note.slice(0, MAX_NOTE);
    return state.logo === 'kylla' ? LOGO_PREFIX + n : n;
  }

  function syncNote() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: buildFullNote() })
      }).catch(function () {});
    }, 400);
  }

  // ── UI event binding ──────────────────────────────────────────

  // Attach state-sync event listeners to an already-rendered .gcs-cart-logo-note wrapper.
  function bindUI(wrap) {
    var btns = wrap.querySelectorAll('.gcs-logo-btn');
    var textarea = wrap.querySelector('.gcs-note-textarea');
    var counter = wrap.querySelector('.gcs-note-counter');

    // Restore current state into this instance
    btns.forEach(function (btn) {
      if (btn.dataset.val === state.logo) btn.classList.add('is-active');
    });
    if (textarea) {
      textarea.value = state.note;
      if (counter) counter.textContent = state.note.length + '/' + MAX_NOTE;
    }

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.logo = btn.dataset.val;
        document.querySelectorAll('.gcs-cart-logo-note').forEach(function (w) {
          w.querySelectorAll('.gcs-logo-btn').forEach(function (b) {
            b.classList.toggle('is-active', b.dataset.val === state.logo);
          });
          w.querySelector('.gcs-logo-error').hidden = true;
        });
        syncNote();
      });
    });

    if (textarea) {
      textarea.addEventListener('input', function () {
        state.note = textarea.value.slice(0, MAX_NOTE);
        document.querySelectorAll('.gcs-note-textarea').forEach(function (ta) {
          if (ta !== textarea) ta.value = state.note;
        });
        document.querySelectorAll('.gcs-note-counter').forEach(function (c) {
          c.textContent = state.note.length + '/' + MAX_NOTE;
        });
        textarea.value = state.note;
        if (counter) counter.textContent = state.note.length + '/' + MAX_NOTE;
        syncNote();
      });
    }
  }

  // ── UI construction (drawer only) ─────────────────────────────

  function buildUI(idSuffix) {
    var uid = 'gcs-cart-logo-note' + (idSuffix ? '-' + idSuffix : '');
    var wrap = document.createElement('div');
    wrap.id = uid;
    wrap.className = 'gcs-cart-logo-note';

    var textareaId = 'gcs-cart-note-input' + (idSuffix ? '-' + idSuffix : '');

    wrap.innerHTML =
      '<div class="gcs-logo-section">' +
        '<p class="gcs-logo-question">Lisää ennalta toimitetut logot työvaatteisiin?</p>' +
        '<div class="gcs-logo-btns">' +
          '<button type="button" class="gcs-logo-btn" data-val="ei">Ei</button>' +
          '<button type="button" class="gcs-logo-btn" data-val="kylla">Kyllä</button>' +
        '</div>' +
        '<p class="gcs-logo-error" hidden>Valitse haluatko logot työvaatteisiin</p>' +
      '</div>' +
      '<div class="gcs-note-section">' +
        '<label class="gcs-note-label" for="' + textareaId + '">Lisätiedot tilaukselle</label>' +
        '<textarea id="' + textareaId + '" class="gcs-note-textarea"' +
          ' placeholder="Kirjoita tähän..." maxlength="' + MAX_NOTE + '" rows="3"></textarea>' +
        '<span class="gcs-note-counter">0/' + MAX_NOTE + '</span>' +
      '</div>';

    bindUI(wrap);
    return wrap;
  }

  // ── Drawer injection ──────────────────────────────────────────

  function injectDrawer() {
    if (document.getElementById('gcs-cart-logo-note-drawer')) return;

    var checkoutBtn =
      document.querySelector('#CartDrawer button[name="checkout"]') ||
      document.querySelector('cart-drawer button[name="checkout"]');
    if (!checkoutBtn) return;

    checkoutBtn.parentElement.insertBefore(buildUI('drawer'), checkoutBtn);
  }

  // ── Cart page binding ─────────────────────────────────────────
  // The UI is rendered by Liquid (sections/main-cart-footer.liquid).
  // We only need to bind events to the already-present element.

  function bindPage() {
    var wrap = document.getElementById('gcs-cart-logo-note-page');
    if (!wrap) return;
    bindUI(wrap);
  }

  // ── Checkout guard ────────────────────────────────────────────

  function showError() {
    document.querySelectorAll('.gcs-cart-logo-note .gcs-logo-error').forEach(function (err) {
      err.hidden = false;
    });
  }

  function setupCheckoutGuard() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('button[name="checkout"]');
      if (!btn) return;
      if (state.logo !== null) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      showError();
    }, true);

    document.addEventListener('submit', function (e) {
      var form = e.target;
      var isCartForm =
        form.id === 'CartDrawer-Form' ||
        form.id === 'cart' ||
        (form.action && form.action.indexOf('/cart') !== -1 && form.querySelector('button[name="checkout"]'));
      if (!isCartForm) return;
      if (state.logo !== null) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      showError();
    }, true);
  }

  // ── MutationObserver — re-inject drawer after cart re-renders ─

  function setupDrawerObserver() {
    if (drawerObserverInstalled) return;

    var root =
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer');
    if (!root) return;

    var observer = new MutationObserver(function () {
      if (!document.getElementById('gcs-cart-logo-note-drawer')) {
        injectDrawer();
      }
    });
    observer.observe(root, { childList: true, subtree: true });
    drawerObserverInstalled = true;
  }

  // ── Init ──────────────────────────────────────────────────────

  function init() {
    injectDrawer();
    bindPage();
    setupCheckoutGuard();
    setupDrawerObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
